const reducer = (state = {id: 'All', label: 'All'}, action) =>{
    switch(action.type){
        case "setSpendMappingType": 
            return action.payload;
        default: 
            return state;
    }
}

export default reducer;  